var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_1302)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "url(#paint0_linear_60_1302)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_60_1302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 30.2584V13H22.0337C23.236 13 24.2275 13.2079 25.0084 13.6236C25.7893 14.0337 26.3708 14.5871 26.7528 15.2837C27.1348 15.9747 27.3258 16.7416 27.3258 17.5843C27.3258 18.3258 27.1938 18.9382 26.9298 19.4213C26.6713 19.9045 26.3287 20.2865 25.9017 20.5674C25.4803 20.8483 25.0225 21.0562 24.5281 21.191V21.3596C25.0562 21.3933 25.5871 21.5787 26.1208 21.9157C26.6545 22.2528 27.1011 22.736 27.4607 23.3652C27.8202 23.9944 28 24.764 28 25.6742C28 26.5393 27.8034 27.3174 27.4101 28.0084C27.0169 28.6994 26.3961 29.2472 25.5478 29.6517C24.6994 30.0562 23.5955 30.2584 22.236 30.2584H16ZM18.0899 28.4045H22.236C23.6011 28.4045 24.5702 28.1404 25.1433 27.6124C25.7219 27.0787 26.0112 26.4326 26.0112 25.6742C26.0112 25.0899 25.8624 24.5506 25.5646 24.0562C25.2669 23.5562 24.8427 23.1573 24.2921 22.8596C23.7416 22.5562 23.0899 22.4045 22.3371 22.4045H18.0899V28.4045ZM18.0899 20.5843H21.9663C22.5955 20.5843 23.1629 20.4607 23.6685 20.2135C24.1798 19.9663 24.5843 19.618 24.882 19.1685C25.1854 18.7191 25.3371 18.191 25.3371 17.5843C25.3371 16.8258 25.073 16.1826 24.5449 15.6545C24.0169 15.1208 23.1798 14.8539 22.0337 14.8539H18.0899V20.5843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 30.2584V30.7584H16H22.236C23.6392 30.7584 24.8243 30.5506 25.763 30.103C26.6863 29.6627 27.3922 29.0508 27.8447 28.2557C28.2845 27.4828 28.5 26.6182 28.5 25.6742C28.5 24.699 28.3072 23.8389 27.8948 23.1171C27.5007 22.4275 27.0003 21.8798 26.3878 21.493C26.206 21.3782 26.0223 21.2779 25.8369 21.193C25.9528 21.128 26.0664 21.0585 26.1778 20.9843C26.6782 20.6548 27.0751 20.209 27.3696 19.6592C27.6846 19.0818 27.8258 18.3809 27.8258 17.5843C27.8258 16.6631 27.6162 15.8123 27.1907 15.0424C26.7565 14.251 26.0992 13.6319 25.2421 13.1816C24.3678 12.7165 23.2892 12.5 22.0337 12.5H16H15.5V13V30.2584ZM25.135 24.312L25.1363 24.3141C25.3865 24.7296 25.5112 25.1796 25.5112 25.6742C25.5112 26.287 25.2847 26.8016 24.8044 27.2447C24.3719 27.6432 23.5618 27.9045 22.236 27.9045H18.5899V22.9045H22.3371C23.0221 22.9045 23.5875 23.0422 24.0508 23.2975L24.0543 23.2994C24.5317 23.5576 24.8869 23.8954 25.135 24.312ZM23.4509 19.7633L23.4509 19.7633L23.4489 19.7643C23.0194 19.9743 22.5285 20.0843 21.9663 20.0843H18.5899V15.3539H22.0337C23.1153 15.3539 23.7948 15.6072 24.1895 16.0062L24.1914 16.008C24.6241 16.4407 24.8371 16.9561 24.8371 17.5843C24.8371 18.1036 24.7087 18.5316 24.4676 18.8888L24.4676 18.8888L24.4652 18.8924C24.2197 19.263 23.8858 19.5531 23.4509 19.7633Z",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_60_1302",
    x: 5.37726,
    y: 8.15091,
    width: 33.2455,
    height: 38.5038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.77364
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.81137
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5 0 0 0 0 0.5 0 0 0 0 0.5 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60_1302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60_1302",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_1302",
    x1: 22,
    y1: 0,
    x2: 30.5508,
    y2: 52.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F066B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_1302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.dc3b0e53b1a1250279dd09610d579125.svg";
export { ForwardRef as ReactComponent };